import React, { CSSProperties, ReactElement } from 'react';

import { TooltipProps as MuiTooltipProps } from '@mui/material/Tooltip';

import { StyledTooltip } from './Tooltip.styles';

export interface TooltipProps extends Omit<MuiTooltipProps, 'sx'> {
    title: ReactElement | string;
    arrow?: boolean;
    tooltipColor?: string;
    tooltipBackground?: string;
    children: ReactElement;
    style?: CSSProperties;
}

export const Tooltip = ({ children, style, ...props }: TooltipProps) => {
    return (
        <StyledTooltip {...props}>
            <div style={style}>{children}</div>
        </StyledTooltip>
    );
};
